import { Injectable } from '@angular/core';
import { HttpServices } from 'src/app/shared/services/http-service.service';
import { TransitRequestDto } from './transit-request.model';
import { TransitAdminDto, TransitAccurateDataDto,ConfirmVesselTransit } from 'src/app/admin/e-services/e-booking/shared/models/transit-admin.model';
import { Observable } from 'rxjs';
import { ResponseObject } from 'src/app/shared/models/response-object.model';
import { TransitRequestCustomDTO ,} from 'src/app/shared/models/transit-request-custom-dto.model';
import { AgentPostponeDto } from 'src/app/admin/e-services/e-booking/shared/models/agent-postpone.model';
import { EbookingRequestTugDTOList } from '../shared/models/ebooking-request-tug.model';


@Injectable({ providedIn: 'root' })
export class TransitService {

  constructor(private http: HttpServices) {
  }


  add(transitRequest: TransitRequestDto) {
    return this.http.post('Transit/Add', transitRequest);
  }
  Update(transitRequest: TransitRequestDto) {
    return this.http.post('Transit/Update', transitRequest);
  }

  get(id: string) {
    return this.http.get('Transit/Get/' + id);
  }
  CancelTransit(data: TransitAdminDto) {
    return this.http.post('Transit/CancelTransit', data);
  }
  postponeTransit(data: AgentPostponeDto) {
    return this.http.post('Transit/postponeTransit', data);
  }

  CheckDuplicateIMONumber(IMONumber: string) {
    return this.http.get('Transit/CheckDuplicateIMONumber?IMONumber=' + IMONumber);
  }
  AddTransitAccurateData(RequestAccurateDataForm: TransitAccurateDataDto) {
    return this.http.post('Transit/AddTransitAccurateData', RequestAccurateDataForm);
  }
  AddConfirmVesselTransit(confirmVesselTransit: ConfirmVesselTransit) {
    return this.http.post('Transit/ConfirmVesselTransit', confirmVesselTransit);
  }

  SubmitConfirmVesselEntranceDecision(dto: TransitRequestCustomDTO) {
    return this.http.post('/Transit/SubmitConfirmVesselEntranceDecision', dto);
  }
  SubmitEstimatedPenalty(dto: TransitRequestCustomDTO) {
    return this.http.post('/Transit/SubmitEstimatedPenalty', dto);
  }
  SubmitConfirmPenaltyDecision(dto: TransitRequestCustomDTO) {
    return this.http.post('/Transit/SubmitConfirmPenaltyDecision', dto);
  }
  SubmitPenaltyFinanaceNotification(dto: TransitRequestCustomDTO) {
    return this.http.post('/Transit/SubmitPenaltyFinanaceNotification', dto);
  }
  SubmitPenaltyMarineNotification(dto: TransitRequestCustomDTO) {
    return this.http.post('/Transit/SubmitPenaltyMarineNotification', dto);
  }
  SubmitMarineOfficerRevewDecision(dto: TransitRequestCustomDTO) {
    return this.http.post('/Transit/SubmitMarineOfficerRevewDecision', dto);
  }
  SubmitMarineOfficerConfirmationDecision(dto: TransitRequestCustomDTO) {
    return this.http.post('/Transit/SubmitMarineOfficerConfirmationDecision', dto);
  }
  SubmitAgentTimeRateDecision(dto: TransitRequestCustomDTO) {
    return this.http.post('/Transit/SubmitAgentTimeRateDecision', dto);
  }

  GetTransitAccurateData(requestID: string) {
    return this.http.get('Transit/GetTransitAccurateData?requestID=' + requestID);
  }

  SubmitConfirmFeesPaymentDecision(dto: TransitRequestCustomDTO) {
    return this.http.post('/Transit/SubmitConfirmFeesPaymentDecision', dto);
  }

  SubmitTransitIssueResolutionDecision(dto: TransitRequestCustomDTO) {
    return this.http.post('/Transit/SubmitTransitIssueResolutionDecision', dto);
  }

  SubmitRefundPaymentDecision(dto: TransitRequestCustomDTO) {
    return this.http.post('/Transit/SubmitRefundPaymentDecision', dto);
  }

  SubmitGuaranteeDeductionLetters(dto: TransitRequestCustomDTO) {
    return this.http.post('/Transit/SubmitGuaranteeDeductionLetters', dto);
  }

  SubmitNavigationDecision(dto: TransitRequestCustomDTO) {
    return this.http.post('/Transit/SubmitNavigationDecision', dto);
  }

  ImposeTugBoats(dto: EbookingRequestTugDTOList) {
    return this.http.post('/Transit/ImposeTugBoats', dto);
  }

  GetImposedTugBoats(requestId: string) {
    return this.http.get('/Transit/GetImposedTugBoats?requestId=' + requestId);
  }

  GetByIMO(IMONO: string) {
    return this.http.get('Transit/GetByIMO?IMONO=' + IMONO);
  }

  GetByTransitRequestAndPenaltyId(transitRequestId: string, penaltyId: number): Observable<ResponseObject> {
    return this.http.get(
      'Transit/GetByTransitRequestAndPenaltyId?transitRequestId=' + transitRequestId + '&penaltyId=' + penaltyId
    );
  }
}
